import React from "react";
import { AiOutlineShopping, AiOutlineFileText, AiOutlineQuestionCircle } from "react-icons/ai";
import Header from "../components/header";
import { Link } from "react-router-dom";

class Main extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: "",
      error: "",
      isLoading: false,
    };
  }

  render() {
    return (
      <div>
        <Header pageName={"Главная"} />
        {/* <p>Абзац</p>
        <div className={'inputWithHint'}>
          <p>asdasd</p>
          <input name='sdfsdf' />
        </div>
        <button className={'btn btn_tdk'}><span>content</span></button> */}
        <Link to="/about-app" className={"topic topic_fullWidth"}>
          <AiOutlineQuestionCircle className={"topic_icon"} />
          <p>О приложении</p>
        </Link>
        <div className="topics">
          <Link to="/sales" className={"topic"}>
            <AiOutlineShopping className={"topic_icon"} />
            <p>Продажи</p>
          </Link>
          <Link to="/templates" className={"topic"}>
            <AiOutlineFileText className={"topic_icon"} />
            <p>Шаблоны</p>
          </Link>
          {/* <div className={'topic disabled'}>
            <AiOutlineShopping className={'topic_icon'} />
            <p>Продажи</p>
          </div>
          <div className={'topic disabled'}>
            <AiOutlineFileText className={'topic_icon'} />
            <p>Шаблоны</p>
          </div> */}
        </div>
      </div>
    );
  }
}

export default Main;
